import React from 'react'
import {Spin, Button,message} from 'antd'
import common from '@/public/common'
import '../returnGoods/index.less'
import {ajaxApi} from '@/server'
import {  getParmUrl, outformat,getCookie,getCookieNew } from '../../public/utils'
import '../returnGoods/index.less'

const urlLink = common.scpUrl + 'change-stack'
class PrintOrder extends React.Component{
    constructor (props) {
        super(props)
        this.state = {
            sping: false,
            data: null
        }
    }
    componentDidMount() {
        this.setState({
            sping: true
        }, () => {
            this.getPrint()
        }) 
    }
    getPrint = () => {
        ajaxApi({
            url: urlLink + '/DeliveryPrint',
            params: {action: 'deliveryprint', data:{POID: getParmUrl('POID'), WHID: getParmUrl('WHID'),s_code:getCookieNew('supplier_code') ? getCookieNew('supplier_code'): null}  }
         }).then(res => {
            if (res.data.flag === true) {
                this.setState({
                    sping: false,
                    data: res.data.data
                })
            } else {
                message.error(res.data.error_message)
            }
        })
    }
    print = () => {
        window.document.body.innerHTML = window.document.getElementsByClassName('printBody')[0].innerHTML;  
        window.print()
        window.location.reload()
    }
    goback = () => {
        this.props.history.go(-1)
    }
    render() {
        const { sping, data } = this.state
        return (<div className="returnList">
            <Spin spinning={sping}>
            <div className="search">
                <div style={{width: '70%',marginLeft: '15%'}} className="printBody">
                    <h1 style={{fontSize: '28px',fontWeight: 'bold',textAlign: 'center'}}>发货单</h1>
                    <p style={{borderTop: '1px solid #e5e5e5',padding: '10px 5px',margin: 0}}>
                        <span style={{display: 'inline-block',width: '35%'}}>客户名称：{getCookie("business_name")}</span>
                        <span>收货地址：{data ? data.except_address : ''}</span>
                    </p>
                    <p style={{borderTop: '1px solid #e5e5e5',padding: '10px 5px',margin: 0}}>
                        <span style={{display: 'inline-block',width: '35%'}}>客户订单号：{data ? data.po_code : ''}</span>
                        <span>客户联系电话：{data ? data.phone : ''}</span>
                    </p>
                    <p style={{borderTop: '1px solid #e5e5e5',padding: '10px 5px',margin: 0}}>
                        <span style={{display: 'inline-block',width: '35%'}}>发货人：</span>
                        <span>发货时间：</span>
                    </p>
                    <p style={{borderTop: '1px solid #e5e5e5',padding: '10px 5px',margin: 0}}>
                        <span>货品数量合计：{data ? outformat(data.sum_count) : ''}</span>
                        <span></span>
                    </p>
                    <table style={{width:'100%'}}>
                        <thead>
                            <tr style={{background:'#e5e5e5'}}>
                                <td style={{width: '11.3%',border: '1px solid',textAlign: 'center',padding: '5px 0'}}>名称</td>
                                <td style={{width: '8.3%',border: '1px solid',textAlign: 'center',padding: '5px 0'}}>型号</td>
                                <td style={{width: '8.3%',border: '1px solid',textAlign: 'center',padding: '5px 0'}}>注册证号</td>
                                <td style={{width: '6.3%',border: '1px solid',textAlign: 'center',padding: '5px 0'}}>单位</td>
                                <td style={{width: '6.3%',border: '1px solid',textAlign: 'center',padding: '5px 0'}}>颜色</td>
                                <td style={{width: '6.3%',border: '1px solid',textAlign: 'center',padding: '5px 0'}}>光度</td>
                                <td style={{width: '8.3%',border: '1px solid',textAlign: 'center',padding: '5px 0'}}>需要发货数量</td>
                                <td style={{width: '8.3%',border: '1px solid',textAlign: 'center',padding: '5px 0'}}>实际发货数量</td>
                                <td style={{width: '8.3%',border: '1px solid',textAlign: 'center',padding: '5px 0'}}>批号</td>
                                <td style={{width: '8.3%',border: '1px solid',textAlign: 'center',padding: '5px 0'}}>生产日期</td>
                                <td style={{width: '8.3%',border: '1px solid',textAlign: 'center',padding: '5px 0'}}>失效日期</td>
                                <td style={{width: '8.3%',border: '1px solid',textAlign: 'center',padding: '5px 0'}}>生产厂家</td>
                            </tr>
                        </thead>
                        <tbody style={{fontSize: '12px'}}>
                            {
                                data ? 
                                data.body_list.map(item => {
                                    return item.back_list.map((e, index) => { 
                                        return <tr>
                                                    <td style={{border: '1px solid',textAlign: 'center',padding: '5px 0', display: index === 0 ? 'bolck' : 'none'}} rowSpan={item.back_list.length}>{item.item_name}</td>
                                                    <td style={{border: '1px solid',textAlign: 'center',padding: '5px 0',display: index === 0 ? 'bolck' : 'none'}} rowSpan={item.back_list.length}></td>
                                                    <td style={{border: '1px solid',textAlign: 'center',padding: '5px 0',display: index === 0 ? 'bolck' : 'none'}} rowSpan={item.back_list.length}></td>
                                                    <td style={{border: '1px solid',textAlign: 'center',padding: '5px 0',display: index === 0 ? 'bolck' : 'none'}} rowSpan={item.back_list.length}>{item.unit}</td>
                                                    <td style={{border: '1px solid',textAlign: 'center',padding: '5px 0'}}>{e.color}</td>
                                                    <td style={{border: '1px solid',textAlign: 'center',padding: '5px 0'}}>{e.degree}</td>
                                                    <td style={{border: '1px solid',textAlign: 'center',padding: '5px 0'}}>{e.need_delivery_quantity}</td>
                                                    <td style={{border: '1px solid',textAlign: 'center',padding: '5px 0'}}></td>
                                                    <td style={{border: '1px solid',textAlign: 'center',padding: '5px 0'}}></td>
                                                    <td style={{border: '1px solid',textAlign: 'center',padding: '5px 0'}}></td>
                                                    <td style={{border: '1px solid',textAlign: 'center',padding: '5px 0'}}></td>
                                                    <td style={{border: '1px solid',textAlign: 'center',padding: '5px 0',display: index === 0 ? 'bolck' : 'none'}} rowSpan={item.back_list.length}></td>
                                              </tr>
                                    }) 
                                }) : ''
                            }
                        </tbody>
                    </table>
                </div>
                <p style={{textAlign: 'center',margin: '20px 0'}}>
                    <Button type="primary" shape="round" onClick={this.print}>打印</Button>
                    <Button shape="round" style={{marginLeft: '25px'}} onClick={this.goback}>返回</Button>
                </p>
            </div>
            </Spin>
        </div>)
    }

}
export default PrintOrder


// WEBPACK FOOTER //
// ./src/pages/orderAdmin/printOrder.js